export default "__VITE_ASSET__DFzDmOIB__"